const allowedOrigin = import.meta.env.VITE_WINDOW_ORIGIN;
const allowedOriginEvyveska = import.meta.env.VITE_WINDOW_ORIGIN_EVYVESKA;

export type HandshakeResponse = {
  isValid: boolean;
  response: 'm4g1c-h4nD5h4k3!';
  isEvyveska: boolean;
};

// there are multiple post message targets so we wrap
export function postMessageToIframeParent(
  message: (
    { type: "handshake", greeting: "Hello from imm" }
    // | { type: "iframeReady" }
    | { /* type: "height", */ height: number }
    | { type: "goHome" }
    | { type: "redirect", id: number }
    | { type: "search", search: string }
    | { type: "copy", content: string }
    ),
) {

  debugIframeMessage("IFRAME message", message, '.search=',decodeURIComponent(message?.search), allowedOriginEvyveska);

  // programmer error
  if (window.parent === window) {
    console.error("Programmer error: Message must be sent with this app being inside of iframe!", message);
    return;
  }

  window.parent.postMessage(
    message,
    allowedOrigin
  );
  window.parent.postMessage(
    message,
    allowedOriginEvyveska
  );
}

export function debugIframeMessage(message: string, ...args: any[]) {

  return true; // TODO: for testing

  console.log("%cIFRAME debug", "background-color:#b0b; color:#fff;", message, ...args);
}
